import PlaceModel2BorderPark from "../../../../../assets/FloorPlanAssets/place_model-2_border_park.svg";
import PlaceModel2BorderElec from "../../../../../assets/FloorPlanAssets/place_model-2_border_elec.svg";

/** White rectangle used with `tint` for live fill colors (create highlight, report overlay). */
export { default as PlaceFillWhite } from "../../../../../assets/FloorPlanAssets/place_fill_white.svg";
/** White rounded rectangle for workplace fills (matches Graphics `drawRoundedRect`). */
export { default as PlaceFillRoundedWhite } from "../../../../../assets/FloorPlanAssets/place_fill_rounded_white.svg";
/** White circle used with `tint` for status / occupancy / report colors. */
export { default as PlaceCircleWhite } from "../../../../../assets/FloorPlanAssets/place_fill_circle_white.svg";
/** Untinted white stroke matching occupancy SVGs (`r=50`, `stroke-width=8` in a 120 viewBox). */
export { default as PlaceCircleRingWhite } from "../../../../../assets/FloorPlanAssets/place_circle_ring_white.svg";

/** Stroke-only parking / charging frames so fill `tint` does not recolor the border. */
export const ParkPlaceBorder = {
  Parking: PlaceModel2BorderPark,
  ElectricCharging: PlaceModel2BorderElec
};

// park place P icon text as svg image
export { default as ParkPlaceIcon } from "../../../../../assets/FloorPlanAssets/place_model-2_icon_park.svg";
